module.exports = __webpack_public_path__ + "static/img/COC2021-28.6eb8276.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-28.jpg
// module id = HYVz
// module chunks = 0